import { useLang } from "@/lib/i18n";

const Row = ({ items, hidden }) => (
  <div className="marquee-row" aria-hidden={hidden || undefined}>
    {items.map((x) => <span key={x}>{x}<i aria-hidden="true">·</i></span>)}
  </div>
);

export const Marquee = () => {
  const { t } = useLang();
  return (
    <div className="marquee" data-testid="services-marquee">
      <div className="marquee-track"><Row items={t.marquee} /><Row items={t.marquee} hidden /></div>
    </div>
  );
};
